import * as React from 'react';
import { T, TPlainTextKey } from '../../Translations';

interface Props {
  count: number;
  singularKind: TPlainTextKey;
  pluralKind: TPlainTextKey;
}

export const PluralizedText: React.FC<Props> = ({ count, singularKind, pluralKind }) => {
  return count === 1 ? <T kind={singularKind} /> : <T kind={pluralKind} />;
};
